import React, { useEffect, useRef, useState } from 'react';
import SelectedOneGoal from './TemplateGoals/SelectedOneGoal';
import './ArrangeYourGoal.css';

const goalKey = (item, index) => {
    if (item?.GoalId != null) return `g-${item.GoalId}`;
    if (item?.idL != null) return `g-${item.idL}`;
    return `g-${item?.areaId ?? 'x'}-${item?.recomendationIndex ?? index}`;
};

const SelectOneSection = (props) => {
    const [dragIndex, setDragIndex] = useState(null);
    const [overIndex, setOverIndex] = useState(null);
    const dragIndexRef = useRef(null);

    useEffect(() => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }, []);

    function reorder(from, to) {
        if (from == null || to == null || from === to) return;

        const arr = [...(props.AllState.SelectedGoalsSeven || [])];
        if (from < 0 || to < 0 || from >= arr.length || to >= arr.length) {
            return;
        }

        const [moved] = arr.splice(from, 1);
        arr.splice(to, 0, moved);

        if (typeof props.changeData === 'function') {
            props.changeData((prev) => ({
                ...prev,
                SelectedGoalsSeven: arr,
                changeData: props.changeData,
            }));
        } else {
            props.AllState.SelectedGoalsSeven.splice(0, arr.length, ...arr);
        }

        if (props.forceUpdate) {
            props.forceUpdate();
        }
    }

    const onDragStart = (e, index) => {
        dragIndexRef.current = index;
        setDragIndex(index);
        setOverIndex(index);
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/plain', String(index));

        const goalCard = e.currentTarget.querySelector('.GoalArrange');
        if (goalCard && e.dataTransfer.setDragImage) {
            e.dataTransfer.setDragImage(
                goalCard,
                goalCard.offsetWidth * 0.5,
                goalCard.offsetHeight * 0.5
            );
        }
    };

    const onDragEnd = () => {
        const from = dragIndexRef.current;
        const to = overIndex;
        dragIndexRef.current = null;
        setDragIndex(null);
        setOverIndex(null);
        if (from != null && to != null) {
            reorder(from, to);
        }
    };

    const onDragOver = (e, index) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
        if (overIndex !== index) {
            setOverIndex(index);
        }
    };

    const onDrop = (e, index) => {
        e.preventDefault();
        const from = dragIndexRef.current;
        dragIndexRef.current = null;
        setDragIndex(null);
        setOverIndex(null);
        if (from != null) {
            reorder(from, index);
        }
    };

    const goals = props.AllState.SelectedGoalsSeven || [];

    return (
        <div className="arrangeYouGoal__container">
            <div className="RecomendationTitleArrange hiddenMobile">
                Arrange your 7 Goals:
            </div>
            <div className="RecomendationTitleArrange visibleMobile">
                Arrange your
            </div>
            <div className="RecomendationTitleArrange visibleMobile">
                7 Goals:
            </div>
            <div className="RecomendationDescArrange">
                <div className="RecomendationDescArrange__text">
                    Drag and drop your goals to rank them by priority. Place
                    your most important goal at the top.
                </div>
            </div>
            <ul
                className={`arrange7GoalList${
                    dragIndex != null ? ' arrange7GoalList--sorting' : ''
                }`}
            >
                {goals.map((itemF, indexF) => {
                    const isDragging = dragIndex === indexF;
                    const isOver =
                        overIndex === indexF &&
                        dragIndex != null &&
                        dragIndex !== indexF;

                    return (
                        <li
                            key={goalKey(itemF, indexF)}
                            data-arrange-index={indexF}
                            draggable
                            onDragStart={(e) => onDragStart(e, indexF)}
                            onDragEnd={onDragEnd}
                            onDragOver={(e) => onDragOver(e, indexF)}
                            onDrop={(e) => onDrop(e, indexF)}
                            onDragEnter={(e) => {
                                e.preventDefault();
                                setOverIndex(indexF);
                            }}
                            className={`arrange7GoalList__item${
                                isDragging
                                    ? ' arrange7GoalList__item--dragging'
                                    : ''
                            }${isOver ? ' arrange7GoalList__item--over' : ''}`}
                            aria-label="Drag to reorder goal"
                        >
                            <SelectedOneGoal
                                updateIndexStep2={props.updateIndexStep2}
                                changeData={props.changeData}
                                AllState={props.AllState}
                                itemF={itemF}
                                indexF={indexF}
                                hideNav={false}
                                Fs={props.AllState.Fs[itemF.areaId]}
                            />
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default SelectOneSection;
